import { render } from "./Classmates.vue?vue&type=template&id=2823ff0d&lang=pug"
import script from "./Classmates.vue?vue&type=script&lang=js"
export * from "./Classmates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__